"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Place = void 0;
const AreaTypes_1 = require("../../types/AreaTypes");
const Geo_1 = require("../Geo");
const typeName = 'Place';
class Place extends Geo_1.GeoModelCommon {
    constructor(ob) {
        super({ ...ob, type: ob.type ?? typeName });
        this.color = ob.color;
        this.icon = ob.icon;
    }
    getUserAttributes() {
        const { tz, ...rest } = super.getUserAttributes();
        return {
            ...rest,
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'identification',
                validation: { regex: /^[\p{L}0-9\s']+$/u, pass: true, invalidMessage: 'Name cannot contain invalid characters' },
            },
            ...AreaTypes_1.CoverageKPIUserAttributes,
        };
    }
}
exports.Place = Place;
